import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import User from "./views/user";
import Order from "./views/order";
import Shop from "./views/shop";
import Machine from "./views/machine";
import Product from "./views/product";
// import Project from "./views/project";
import Report from "./views/report";
import AllOrderStatic from "./views/report/pages/allOrder.vue";
import ShopOrderStatic from "./views/report/pages/shopOrder.vue";
// import CityOrderStatic from "./views/report/pages/cityOrder.vue";
import MachineUseCountStatistic from "./views/report/pages/machineUseCountStatistic.vue";
import VendorOrderStatic from "./views/report/pages/vendorOrder.vue";
import Rank from "./views/report/pages/rank.vue";
import UserGrowth from "./views/report/pages/userGrowth.vue";

import Comment from "./views/comment";
import Refund from "./views/refund";
import JoinIn from "./views/joinIn";
import Fault from "./views/fault";
import Liquid from "./views/liquid";
import LiquidFeeder from "./views/liquid/liquidFeeder";
import MachineOfflineLog from "./views/machineOfflineLog/index.vue";
import HeartBeat from "./views/heartbeat";
import NotifyMessage from "./views/notifyMessage";
import NotifyMessagePublic from "./views/notifyMessagePublic";
import Payment from "./views/payment";
import Admin from "./views/admin";
import Log from "./views/log";
import BindProduct from "./views/product/bindProduct.vue";

//分账管理
import BillManagement from "./views/billManagement";
import BillListStatistic from "./views/billManagement/billListStatistic.vue";
import BillList from "./views/billManagement/billList.vue";
import Withdraw from "./views/withdraw/index.vue";

//发票管理
import Receipt from "./views/receipt/index.vue";

/**登录页面 */
import Login from "./views/login";

Vue.use(Router);
const routerPush = Router.prototype.push;
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => {
    console.log("捕获route push错误");
    error;
  });
};
Router.prototype.replace = function replace (location) {
  return routerPush.call(this, location).catch(error => {
    console.log("捕获route replace错误");
    error;
  });
};
export default new Router({
  routes: [
    /**首页 */
    {
      path: "/",
      name: "home",
      component: Home,
      children: [
        /**用户管理 */
        {
          path: "user",
          name: "user",
          component: User
        },
        /**订单管理 */
        {
          path: "order",
          name: "order",
          component: Order
        },
        /**门店管理 */
        {
          path: "shop",
          name: "shop",
          component: Shop
        },
        /**机器管理 */
        {
          path: "machine",
          name: "machine",
          component: Machine
        },
        /**产品模板管理 */
        {
          path: "product",
          name: "product",
          component: Product
        },
        /**绑定产品管理 */
        {
          path: "bindproduct",
          name: "bindproduct",
          component: BindProduct
        },
        // /**项目管理 */
        // {
        //   path: "project",
        //   name: "project",
        //   component: Project
        // },
        /**评论管理 */
        {
          path: "comment",
          name: "comment",
          component: Comment
        },
        /**独特优惠券 */
        {
          path: "uniqueCoupon",
          name: "uniqueCoupon",
          component: () => import("./views/uniqueCoupon/index.vue")
        },
        /**退款管理 */
        {
          path: "refund",
          name: "refund",
          component: Refund
        },
        /**加盟管理 */
        {
          path: "joinIn",
          name: "joinIn",
          component: JoinIn
        },
        /**心跳管理 */
        {
          path: "heartBeat",
          name: "heartBeat",
          component: HeartBeat
        },
        /**离线数据 */
        {
          path: "MachineOfflineLog",
          name: "MachineOfflineLog",
          component: MachineOfflineLog
        },
        /**上报数据 */
        {
          path: "notifyMessage",
          name: "notifyMessage",
          component: NotifyMessage
        },
        /**故障管理 */
        {
          path: "fault",
          name: "fault",
          component: Fault
        },
        /**加液管理 */
        {
          path: "liquid",
          name: "liquid",
          component: Liquid
        },
        /**加液设备 */
        {
          path: "liquidFeeder",
          name: "liquidFeeder",
          component: LiquidFeeder
        },
        /**支付管理 */
        {
          path: "payment",
          name: "payment",
          component: Payment
        },
        /**管理员列表*/
        {
          path: "admin",
          name: "admin",
          component: Admin
        },
        /**统计分析报告 */
        {
          path: "report",
          name: "report",
          component: Report,
          children: [
            //全局订单统计
            {
              path: "allOrderStatic",
              name: "allOrderStatic",
              component: AllOrderStatic
            },
            //门店订单统计
            {
              path: "shopOrderStatic",
              name: "shopOrderStatic",
              component: ShopOrderStatic
            },
            //城市订单统计
            // {
            //   path: "cityOrderStatic",
            //   name: "cityOrderStatic",
            //   component: CityOrderStatic
            // },

            //机器使用率
            {
              path: "machineUseCountStatistic",
              name: "machineUseCountStatistic",
              component: MachineUseCountStatistic
            },
            //产品统计
            {
              path: "vendorOrderStatic",
              name: "vendorOrderStatic",
              component: VendorOrderStatic
            },
            //排名
            {
              path: "rank",
              name: "rank",
              component: Rank
            },
            //用户增长排名
            {
              path: "userGrowth",
              name: "userGrowth",
              component: UserGrowth
            }
          ]
        },
        /**日志管理 */
        {
          path: "log",
          name: "log",
          component: Log
        },

        /**账单明细 */
        {
          path: "billList",
          name: "billList",
          component: BillList
        },
        /**账单分析 */
        {
          path: "billListStatistic",
          name: "billListStatistic",
          component: BillListStatistic
        },

        /**账单分析 */
        {
          path: "withdraw",
          name: "withdraw",
          component: Withdraw
        },

        /**分账管理 */
        {
          path: "billManagement",
          name: "billManagement",
          component: BillManagement
        },

        /**发票管理 */
        {
          path: "receipt",
          name: "receipt",
          component: Receipt
        },

        /**优惠券 */
        {
          path: "coupon",
          name: "coupon",
          component: resolve => require(["./views/coupon/index.vue"], resolve)
        },
        /**VIP */
        {
          path: "vip",
          name: "vip",
          component: resolve => require(["./views/vip/index.vue"], resolve)
        },
        /**总代理管理 */
        {
          path: "agent",
          name: "agent",
          component: resolve => require(["./views/agent/index.vue"], resolve)
        },
        /*定时优惠 */
        {
          path: "timediscount",
          name: "timediscount",
          component: resolve =>
            require(["./views/timeDiscount/index.vue"], resolve)
        },
        /**广告管理 */
        {
          path: "advertisement",
          name: "advertisement",
          component: resolve =>
            require(["./views/advertisement/index.vue"], resolve)
        },

        /**余额管理 */
        {
          path: "deposit",
          name: "deposit",
          component: resolve =>
            require(["./views/deposit/index.vue"], resolve)
        }
      ]
    },
    /**登录 */
    {
      path: "/login",
      name: "login",
      component: Login
    },
    /**上报数据-公开访问（独立页面，无菜单） */
    {
      path: "/notifyMessagePublic",
      name: "notifyMessagePublic",
      component: NotifyMessagePublic
    }
  ]
});
